import { Row, Col, Card, FormGroup, Label } from "reactstrap";
import { useContext, useEffect, useState } from "react";
import { ContactContext } from "../../ContextProvider";
import { getContactChargesApi } from "../../../../Shared/Api/GetContactCharges";
import { getDistrictsApi } from "../../../../Shared/Api/GetDistricts";
import { getPoliticSpacesApi } from "../../../../Shared/Api/GetPoliticSpaces";
import { getJurisdictionsApi } from "../../../../Shared/Api/GetJurisdictions";
import { getBlocksApi } from "../../../../Shared/Api/GetBlocks";
import { Typeahead } from "react-bootstrap-typeahead";
import { getEntitiesApi } from "../../../../Shared/Api/GetEntities";
import { getComissionsApi } from "../../../../Shared/Api/GetComissions";

export default function ListHeader() {
  const { filters, setFilters, setSearchTerm } = useContext(ContactContext);
  const optionPhoto = ["Con foto", "Sin foto"]
  //state
  const [charges, setCharges] = useState([]);
  const [jurisdictions, setJurisdictions] = useState([]);
  const [politicSpaces, setPoliticSpaces] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [comissions, setComissions] = useState([]);
  const [entities, setEntities] = useState([]);
  const [blocks, setBlocks] = useState([]);
  const [jurisdiction, setJurisdiction] = useState(); 
  


  /// manejos del componente
  const fetchCharges = async () => {
    let response = await getContactChargesApi();

    if (response.result === "success") {
      setCharges([{ id: 0, name: "SIN CARGO" }, ...response.data.items]);
    }
  };
  const fetchJurisdictions = async () => {
    let response = await getJurisdictionsApi();
    if (response.result === "success") {
      setJurisdictions([
        { id: 0, name: "SIN JURISDICCION" },
        ...response.data.items,
      ]);
    }
  };
  const fetchPoliticSpaces = async () => {
    let response = await getPoliticSpacesApi();
    if (response.result === "success") {
      setPoliticSpaces([
        { id: 0, name: "SIN ESPACIO POLITICO" },
        ...response.data.items,
      ]);
    }
  };
  const fetchDistricts = async () => {
    let response = await getDistrictsApi();
    if (response.result === "success") {
      setDistricts([{ id: 0, name: "SIN DISTRITO" }, ...response.data.items]);
    }
  };
  const fetchBlocks = async () => {
    let response = await getBlocksApi({
      jurisdiction_id: jurisdiction,
    });
    if (response.result === "success") {
      setBlocks([{ id: 0, name: "SIN BLOQUE" }, ...response.data.items]);
    }
  };
  const fetchComissions = async () => {
    let response = await getComissionsApi({
      jurisdiction_id: jurisdiction,
    });
    if (response.result === "success") {
      setComissions([{ id: 0, name: "SIN COMISSION" }, ...response.data.items]);
    }
  };
  const fetchEntities = async () => {
    let response = await getEntitiesApi({
      entity_id: jurisdiction,
    });
    if (response.result === "success") {
      setEntities([{ id: 0, name: "SIN ENTIDAD" }, ...response.data.items]);
    }
  };

  useEffect(() => {
    fetchCharges();
    fetchJurisdictions();
    fetchPoliticSpaces();
    fetchDistricts();
    fetchBlocks();
    fetchEntities();

    return () => {
      setSearchTerm("");
      setFilters([]);
    }; 
  }, []);

  const handleChangeCharge = async (e) => {
    setFilters({
      ...filters,
      ...{
        contact_charge_id:
          e.lenght > 0 != undefined ? e.map((val) => val.id) : "",
      },
    });
  };

  const handleChangeJurisdiction = async (e) => {
    setFilters({
      ...filters,
      ...{
        jurisdiction_id:
          e.lenght > 0 != undefined ? e.map((val) => val.id) : "",
      },
    });

    setJurisdiction(
      e.lenght > 0 != undefined ? e.map((val) => val.id) : undefined
    );
  };

  useEffect(() => {
    fetchBlocks();
    fetchComissions();
  }, [jurisdiction]);

  const handleChangePoliticSpace = async (e) => {
    setFilters({
      ...filters,
      ...{
        politic_space_id:
          e.lenght > 0 != undefined ? e.map((val) => val.id) : "",
      },
    });
  };
  const handleChangeDistrict = async (e) => {
    setFilters({
      ...filters,
      ...{
        district_id: e.lenght > 0 != undefined ? e.map((val) => val.id) : "",
      },
    });
  };
  const handleChangeBlock = async (e) => {
    setFilters({
      ...filters,
      ...{ block_id: e.lenght > 0 != undefined ? e.map((val) => val.id) : "" },
    });
  };
  const handleChangeComission = async (e) => {
    setFilters({
      ...filters,
      ...{
        comission_id: e.lenght > 0 != undefined ? e.map((val) => val.id) : "",
      },
    });
  };
  const handleChangeEntities = async (e) => {
    setFilters({
      ...filters,
      ...{
        entity_id: e.lenght > 0 != undefined ? e.map((val) => val.id) : "",
      },
    });
  };

  const handleOptionPhoto = (e) =>{
    setFilters({
      ...filters,
      ...{
        avatar_url:0
      },
    });
   if(e[0]=="Con foto"){
    setFilters({
      ...filters,
      ...{
        avatar_url:1
      },
    });
   }else if(!e[0]){    
    setFilters({
      ...filters,
      ...{
        avatar_url:"all"
      },
    });
   }
    
  }

  return (
    <Col md="12" className="project-list">
      <Card>
        {/*!! RECUERDA USAR EL ECCOMMERCE FILTERS COMO EJEMPLO */}
        <Row className="mb-3">
          <Col md="3">
            <FormGroup>
              <Typeahead
                id="public-typeahead"
                labelKey="name"
                multiple
                options={charges}
                placeholder="Filtrar por cargo"
                onChange={handleChangeCharge}
              />
            </FormGroup>
          </Col>
          <Col md="3">
            <FormGroup>
              <Typeahead
                id="public-typeahead"
                labelKey="name"
                multiple
                options={jurisdictions}
                placeholder="Filtrar por jurisdiccion"
                onChange={handleChangeJurisdiction}
              />
            </FormGroup>
          </Col>
          <Col md="3">
            <FormGroup>
              <Typeahead
                id="public-typeahead"
                labelKey="name"
                multiple
                options={politicSpaces}
                placeholder="Filtrar por espacio politico"
                onChange={handleChangePoliticSpace}
              />
            </FormGroup>
          </Col>

          <Col md="3">
            <FormGroup>
              <Typeahead
                id="public-typeahead"
                labelKey="name"
                multiple
                options={blocks}
                placeholder="Filtrar por bloque"
                onChange={handleChangeBlock}
              />
            </FormGroup>
          </Col>
          <Col md="3">
            <FormGroup>
              <Typeahead
                id="public-typeahead"
                labelKey="name"
                multiple
                options={districts}
                placeholder="Filtrar por distrito"
                onChange={handleChangeDistrict}
              />
            </FormGroup>
          </Col>

          <Col md="3">
            <FormGroup>
              <Typeahead
                id="public-typeahead"
                labelKey="name"
                multiple
                options={comissions}
                placeholder="Filtrar por comision"
                onChange={handleChangeComission}
              />
            </FormGroup>
          </Col>
          <Col md="3">
            <FormGroup>
              <Typeahead
                id="public-typeahead"
                labelKey="name"
                multiple
                options={entities}
                placeholder="Filtrar por entidad"
                onChange={handleChangeEntities}
              />
            </FormGroup>
          </Col>
          <Col md="3">
            <FormGroup>
              <Typeahead
                id="public-typeahead"
                labelKey="name"
                options={optionPhoto}
                placeholder="Filtrar por fotos"
                onChange={handleOptionPhoto}
                inputProps={{ readOnly: true }}
                clearButton={true}
              />
            </FormGroup>
          </Col>
        </Row>
      </Card>
    </Col>
  );
}
